/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import { FC } from "react";
import { Box, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

export interface ValidationResultMessageProps {
  errorMessage: string;
}

const ValidationResultMessage: FC<ValidationResultMessageProps> = ({
  errorMessage,
}: ValidationResultMessageProps) => {
  return (
    <Box display="flex" alignItems="center" sx={{ margin: "8px 0 8px 0" }}>
      <ErrorIcon sx={{ marginRight: 1 }} color="error" />
      <Typography variant="body2" color="error">
        {errorMessage}
      </Typography>
    </Box>
  );
};

export default ValidationResultMessage;
